export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: Chapter[];
  tags: string[];
  updatedAt: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '浪漫爱情', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国爱情漫画，讲述动人感情故事' },
  { name: '奇幻冒险', slug: 'fantasy', icon: 'ri-magic-line', description: '充满想象力的奇幻世界冒险故事' },
  { name: '都市生活', slug: 'urban', icon: 'ri-building-line', description: '现代都市背景下的精彩生活故事' },
  { name: '悬疑推理', slug: 'mystery', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理韩漫作品' },
  { name: '动作热血', slug: 'action', icon: 'ri-flashlight-line', description: '热血沸腾的动作打斗漫画' },
  { name: '治愈日常', slug: 'healing', icon: 'ri-sun-line', description: '温暖治愈的日常向韩国漫画' },
  { name: '古风历史', slug: 'historical', icon: 'ri-ancient-gate-line', description: '古风历史题材的韩漫佳作' },
  { name: 'BL/GL', slug: 'bl-gl', icon: 'ri-user-heart-line', description: '精彩纷呈的BL/GL韩国漫画' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'the-romance-of-seoul',
    title: '首尔恋歌',
    author: '金敏雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20romantic%20couple%20in%20Seoul%20cityscape%20at%20sunset%2C%20soft%20warm%20lighting%2C%20delicate%20art%20style%2C%20pastel%20color%20palette%2C%20cherry%20blossom%20petals%20floating%2C%20emotional%20atmosphere%2C%20clean%20composition%20with%20simple%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    description: '在首尔繁华的街头，两个陌生人的命运交织在一起。一个是努力奋斗的职场新人，一个是神秘的音乐制作人，他们的相遇改变了彼此的人生轨迹。这部漫画以细腻的笔触描绘了现代都市中的浪漫爱情故事。',
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    tags: ['爱情', '都市', '职场', '音乐'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: '1-1', title: '第1话 命运的交汇', number: 1, updatedAt: '2026-06-01' },
      { id: '1-2', title: '第2话 意外的重逢', number: 2, updatedAt: '2026-06-08' },
      { id: '1-3', title: '第3话 心动的瞬间', number: 3, updatedAt: '2026-06-15' },
      { id: '1-4', title: '第4话 深夜的短信', number: 4, updatedAt: '2026-06-22' },
      { id: '1-5', title: '第5话 他的秘密', number: 5, updatedAt: '2026-06-29' },
      { id: '1-6', title: '第6话 靠近的心', number: 6, updatedAt: '2026-07-06' },
      { id: '1-7', title: '第7话 温柔的告白', number: 7, updatedAt: '2026-07-13' },
      { id: '1-8', title: '第8话 一起的时光', number: 8, updatedAt: '2026-07-20' },
      { id: '1-9', title: '第9话 考验来临', number: 9, updatedAt: '2026-07-27' },
      { id: '1-10', title: '第10话 坚定的选择', number: 10, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: '2',
    slug: 'dragon-realm-adventure',
    title: '龙域冒险记',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20young%20warrior%20with%20a%20dragon%20companion%20in%20a%20magical%20realm%2C%20vibrant%20colors%2C%20epic%20adventure%20theme%2C%20detailed%20character%20design%2C%20magical%20particles%20floating%2C%20mystical%20forest%20background%2C%20clean%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '少年艾伦意外获得与龙族沟通的能力，被卷入了一场关乎两个世界存亡的宏大冒险。与伙伴们一起穿越神秘大陆，揭开古老的预言，对抗黑暗势力的阴谋。',
    status: '连载中',
    rating: 4.9,
    views: 2380000,
    tags: ['奇幻', '冒险', '龙', '魔法'],
    updatedAt: '2026-08-05',
    chapters: [
      { id: '2-1', title: '第1话 龙之召唤', number: 1, updatedAt: '2026-05-15' },
      { id: '2-2', title: '第2话 觉醒的力量', number: 2, updatedAt: '2026-05-22' },
      { id: '2-3', title: '第3话 踏上旅途', number: 3, updatedAt: '2026-05-29' },
      { id: '2-4', title: '第4话 暗影森林', number: 4, updatedAt: '2026-06-05' },
      { id: '2-5', title: '第5话 精灵族的秘密', number: 5, updatedAt: '2026-06-12' },
      { id: '2-6', title: '第6话 古老的预言', number: 6, updatedAt: '2026-06-19' },
      { id: '2-7', title: '第7话 龙之谷', number: 7, updatedAt: '2026-06-26' },
      { id: '2-8', title: '第8话 试炼开始', number: 8, updatedAt: '2026-07-03' },
      { id: '2-9', title: '第9话 暗之军团', number: 9, updatedAt: '2026-07-10' },
      { id: '2-10', title: '第10话 决战前夕', number: 10, updatedAt: '2026-07-17' },
      { id: '2-11', title: '第11话 光明与黑暗', number: 11, updatedAt: '2026-07-24' },
      { id: '2-12', title: '第12话 新的开始', number: 12, updatedAt: '2026-07-31' },
    ],
  },
  {
    id: '3',
    slug: 'office-love-diary',
    title: '办公室恋爱日记',
    author: '李秀妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20manhwa%20cover%20depicting%20office%20romance%20with%20two%20young%20professionals%20in%20business%20attire%20sharing%20a%20tender%20moment%2C%20warm%20indoor%20lighting%2C%20stylish%20contemporary%20art%2C%20subtle%20romantic%20atmosphere%2C%20clean%20background%20with%20office%20elements&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    description: '林智恩是一家广告公司的新人设计师，她暗恋着公司里才华横溢但性格冷淡的艺术总监。一次意外的项目合作让两人有了更多接触的机会，办公室里的暗恋故事就此展开。',
    status: '已完结',
    rating: 4.7,
    views: 980000,
    tags: ['都市', '职场', '爱情', '办公室'],
    updatedAt: '2026-07-20',
    chapters: [
      { id: '3-1', title: '第1话 初入职场', number: 1, updatedAt: '2025-09-01' },
      { id: '3-2', title: '第2话 冷面上司', number: 2, updatedAt: '2025-09-08' },
      { id: '3-3', title: '第3话 加班夜', number: 3, updatedAt: '2025-09-15' },
      { id: '3-4', title: '第4话 咖啡的温度', number: 4, updatedAt: '2025-09-22' },
      { id: '3-5', title: '第5话 出差同行', number: 5, updatedAt: '2025-09-29' },
      { id: '3-6', title: '第6话 心照不宣', number: 6, updatedAt: '2025-10-06' },
      { id: '3-7', title: '第7话 公司聚会', number: 7, updatedAt: '2025-10-13' },
      { id: '3-8', title: '第8话 告白', number: 8, updatedAt: '2025-10-20' },
    ],
  },
  {
    id: '4',
    slug: 'shadow-detective',
    title: '暗影侦探',
    author: '崔正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Korean%20manhwa%20cover%20with%20a%20detective%20in%20trench%20coat%20standing%20in%20a%20dark%20alley%2C%20noir%20atmosphere%2C%20dramatic%20lighting%20with%20long%20shadows%2C%20mysterious%20cityscape%20at%20night%2C%20suspenseful%20mood%2C%20cool%20tone%20color%20palette%2C%20clean%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '前刑警姜赫创办了一家私人侦探社，专门接手警方无法解决的悬案。一桩看似普通的失踪案背后，隐藏着一个横跨多年的惊天阴谋。每一步都走在刀尖上，真相远比想象中更加黑暗。',
    status: '连载中',
    rating: 4.6,
    views: 760000,
    tags: ['悬疑', '推理', '侦探', '犯罪'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: '4-1', title: '第1话 离职', number: 1, updatedAt: '2026-04-10' },
      { id: '4-2', title: '第2话 第一件委托', number: 2, updatedAt: '2026-04-17' },
      { id: '4-3', title: '第3话 失踪的女子', number: 3, updatedAt: '2026-04-24' },
      { id: '4-4', title: '第4话 线索', number: 4, updatedAt: '2026-05-01' },
      { id: '4-5', title: '第5话 目击者', number: 5, updatedAt: '2026-05-08' },
      { id: '4-6', title: '第6话 过去的阴影', number: 6, updatedAt: '2026-05-15' },
      { id: '4-7', title: '第7话 追查到底', number: 7, updatedAt: '2026-05-22' },
      { id: '4-8', title: '第8话 真相浮现', number: 8, updatedAt: '2026-05-29' },
    ],
  },
  {
    id: '5',
    slug: 'blazing-spirit',
    title: '烈焰之魂',
    author: '郑泰元',
    cover: 'https://readdy.ai/api/search-image?query=Action%20packed%20Korean%20manhwa%20cover%20with%20a%20martial%20artist%20surrounded%20by%20flames%2C%20dynamic%20fighting%20pose%2C%20intense%20battle%20scene%2C%20fiery%20red%20and%20orange%20color%20scheme%2C%20powerful%20energy%20effects%2C%20clean%20heroic%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '在武道盛行的世界里，少年韩烈背负着家族被灭的仇恨，踏上了成为最强武者的道路。每一次战斗都是一次成长，每一滴汗水都在浇灌复仇的火焰。',
    status: '连载中',
    rating: 4.5,
    views: 1560000,
    tags: ['动作', '格斗', '热血', '复仇'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: '5-1', title: '第1话 灭门之夜', number: 1, updatedAt: '2026-03-01' },
      { id: '5-2', title: '第2话 幸存者', number: 2, updatedAt: '2026-03-08' },
      { id: '5-3', title: '第3话 拜师学艺', number: 3, updatedAt: '2026-03-15' },
      { id: '5-4', title: '第4话 地狱训练', number: 4, updatedAt: '2026-03-22' },
      { id: '5-5', title: '第5话 初战告捷', number: 5, updatedAt: '2026-03-29' },
      { id: '5-6', title: '第6话 武斗大会', number: 6, updatedAt: '2026-04-05' },
      { id: '5-7', title: '第7话 强敌出现', number: 7, updatedAt: '2026-04-12' },
      { id: '5-8', title: '第8话 突破极限', number: 8, updatedAt: '2026-04-19' },
      { id: '5-9', title: '第9话 真相的碎片', number: 9, updatedAt: '2026-04-26' },
      { id: '5-10', title: '第10话 烈焰觉醒', number: 10, updatedAt: '2026-05-03' },
    ],
  },
  {
    id: '6',
    slug: 'cat-cafe-diary',
    title: '猫咪咖啡馆',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20manhwa%20cover%20showing%20a%20cozy%20cat%20cafe%20interior%20with%20cute%20cats%20and%20a%20gentle%20barista%2C%20soft%20warm%20sunlight%20streaming%20through%20windows%2C%20pastel%20color%20palette%2C%20relaxing%20atmosphere%2C%20clean%20wholesome%20illustration%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '治愈日常',
    categorySlug: 'healing',
    description: '厌倦了都市生活的素熙辞去工作，在首尔的小巷里开了一家猫咪咖啡馆。在这里，她遇到了形形色色的客人和可爱的流浪猫，每一天都是温暖治愈的小确幸。',
    status: '连载中',
    rating: 4.9,
    views: 890000,
    tags: ['治愈', '日常', '猫咪', '咖啡馆'],
    updatedAt: '2026-08-02',
    chapters: [
      { id: '6-1', title: '第1话 辞职的决定', number: 1, updatedAt: '2026-05-01' },
      { id: '6-2', title: '第2话 小巷里的店铺', number: 2, updatedAt: '2026-05-08' },
      { id: '6-3', title: '第3话 第一位客人', number: 3, updatedAt: '2026-05-15' },
      { id: '6-4', title: '第4话 流浪猫小橘', number: 4, updatedAt: '2026-05-22' },
      { id: '6-5', title: '第5话 雨天来客', number: 5, updatedAt: '2026-05-29' },
      { id: '6-6', title: '第6话 温暖的拿铁', number: 6, updatedAt: '2026-06-05' },
      { id: '6-7', title: '第7话 新朋友', number: 7, updatedAt: '2026-06-12' },
      { id: '6-8', title: '第8话 咖啡馆的日常', number: 8, updatedAt: '2026-06-19' },
    ],
  },
  {
    id: '7',
    slug: 'joseon-flower',
    title: '朝鲜之花',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20cover%20featuring%20a%20beautiful%20woman%20in%20traditional%20hanbok%20dress%20in%20Joseon%20era%20palace%20setting%2C%20elegant%20classical%20art%20style%2C%20soft%20traditional%20colors%2C%20cherry%20blossoms%20and%20traditional%20architecture%2C%20graceful%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '古风历史',
    categorySlug: 'historical',
    description: '朝鲜时代，一位出身贫寒的女子凭借过人的智慧和勇气进入宫廷，在权力与爱情的漩涡中挣扎求生。她能否在错综复杂的宫廷斗争中守住自己的本心？',
    status: '连载中',
    rating: 4.7,
    views: 1120000,
    tags: ['古风', '历史', '宫廷', '爱情'],
    updatedAt: '2026-08-01',
    chapters: [
      { id: '7-1', title: '第1话 进宫', number: 1, updatedAt: '2026-02-10' },
      { id: '7-2', title: '第2话 宫女生活', number: 2, updatedAt: '2026-02-17' },
      { id: '7-3', title: '第3话 东宫殿下', number: 3, updatedAt: '2026-02-24' },
      { id: '7-4', title: '第4话 后宫风波', number: 4, updatedAt: '2026-03-03' },
      { id: '7-5', title: '第5话 意外的恩宠', number: 5, updatedAt: '2026-03-10' },
      { id: '7-6', title: '第6话 阴谋暗涌', number: 6, updatedAt: '2026-03-17' },
      { id: '7-7', title: '第7话 抉择', number: 7, updatedAt: '2026-03-24' },
      { id: '7-8', title: '第8话 夜宴', number: 8, updatedAt: '2026-03-31' },
    ],
  },
  {
    id: '8',
    slug: 'spring-breeze',
    title: '春风拂过',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=A%20delicate%20BL%20genre%20Korean%20manhwa%20cover%20with%20two%20young%20men%20sharing%20a%20gentle%20embrace%20under%20cherry%20blossom%20trees%2C%20soft%20spring%20pastel%20colors%2C%20romantic%20tender%20atmosphere%2C%20flowing%20art%20style%2C%20dreamy%20aesthetic%20with%20floating%20petals&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'BL/GL',
    categorySlug: 'bl-gl',
    description: '大学校园里，两个性格迥异的男生因为一次偶然的选修课相遇。一个是阳光开朗的体育生，一个是安静内向的图书管理员，春风吹过，一段美好的感情悄然绽放。',
    status: '连载中',
    rating: 4.8,
    views: 1450000,
    tags: ['校园', '爱情', 'BL', '青春'],
    updatedAt: '2026-08-05',
    chapters: [
      { id: '8-1', title: '第1话 选修课', number: 1, updatedAt: '2026-04-01' },
      { id: '8-2', title: '第2话 图书馆偶遇', number: 2, updatedAt: '2026-04-08' },
      { id: '8-3', title: '第3话 小组作业', number: 3, updatedAt: '2026-04-15' },
      { id: '8-4', title: '第4话 心动的理由', number: 4, updatedAt: '2026-04-22' },
      { id: '8-5', title: '第5话 深夜电话', number: 5, updatedAt: '2026-04-29' },
      { id: '8-6', title: '第6话 运动会', number: 6, updatedAt: '2026-05-06' },
      { id: '8-7', title: '第7话 樱花下的约定', number: 7, updatedAt: '2026-05-13' },
      { id: '8-8', title: '第8话 夏天的开始', number: 8, updatedAt: '2026-05-20' },
    ],
  },
  {
    id: '9',
    slug: 'starry-night-promise',
    title: '星空下的约定',
    author: '金敏雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20with%20a%20couple%20gazing%20at%20starry%20night%20sky%20on%20a%20hilltop%2C%20magical%20night%20atmosphere%2C%20twinkling%20stars%2C%20soft%20moonlight%2C%20warm%20romantic%20mood%2C%20clean%20illustration%20style%20with%20dreamy%20quality&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    description: '天文系学生尹星和摄影师李夜在星空观测活动中相识。一个是仰望星空的梦想家，一个是记录瞬间的艺术家。在浩瀚星空下，两颗心渐渐靠近。',
    status: '已完结',
    rating: 4.6,
    views: 870000,
    tags: ['爱情', '星空', '摄影', '大学'],
    updatedAt: '2026-06-30',
    chapters: [
      { id: '9-1', title: '第1话 流星雨之夜', number: 1, updatedAt: '2025-11-01' },
      { id: '9-2', title: '第2话 照片里的她', number: 2, updatedAt: '2025-11-08' },
      { id: '9-3', title: '第3话 天文台', number: 3, updatedAt: '2025-11-15' },
      { id: '9-4', title: '第4话 北极星的指引', number: 4, updatedAt: '2025-11-22' },
      { id: '9-5', title: '第5话 银河之旅', number: 5, updatedAt: '2025-11-29' },
      { id: '9-6', title: '第6话 永远的约定', number: 6, updatedAt: '2025-12-06' },
    ],
  },
  {
    id: '10',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20academy%20Korean%20manhwa%20cover%20with%20students%20in%20robes%20casting%20spells%20in%20a%20grand%20magical%20school%20hallway%2C%20colorful%20magic%20effects%2C%20fantasy%20setting%2C%20vibrant%20warm%20colors%2C%20detailed%20architectural%20background%2C%20clean%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '普通高中生林夏意外收到魔法学院的录取通知书，从此踏上学习魔法的奇妙旅程。在这里，她结识了性格各异的同学，共同面对魔法世界的挑战与冒险。',
    status: '连载中',
    rating: 4.7,
    views: 1890000,
    tags: ['奇幻', '魔法', '学院', '冒险'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: '10-1', title: '第1话 神秘的信件', number: 1, updatedAt: '2026-03-15' },
      { id: '10-2', title: '第2话 踏入魔法世界', number: 2, updatedAt: '2026-03-22' },
      { id: '10-3', title: '第3话 分院仪式', number: 3, updatedAt: '2026-03-29' },
      { id: '10-4', title: '第4话 第一堂魔法课', number: 4, updatedAt: '2026-04-05' },
      { id: '10-5', title: '第5话 禁林探险', number: 5, updatedAt: '2026-04-12' },
      { id: '10-6', title: '第6话 魔法对决', number: 6, updatedAt: '2026-04-19' },
      { id: '10-7', title: '第7话 古老的秘密', number: 7, updatedAt: '2026-04-26' },
      { id: '10-8', title: '第8话 期末考验', number: 8, updatedAt: '2026-05-03' },
    ],
  },
  {
    id: '11',
    slug: 'midnight-snack',
    title: '深夜食堂',
    author: '李秀妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20Korean%20manhwa%20cover%20showing%20a%20warm%20late%20night%20restaurant%20interior%20with%20steaming%20food%20and%20diverse%20customers%2C%20warm%20yellow%20lighting%2C%20comforting%20atmosphere%2C%20detailed%20food%20illustrations%2C%20clean%20slice%20of%20life%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    description: '在首尔一条不起眼的小巷里，有一家只在深夜营业的小餐馆。老板用一道道温暖的美食，慰藉着都市夜归人的胃和心。每一道菜背后都有一个动人的故事。',
    status: '连载中',
    rating: 4.8,
    views: 1340000,
    tags: ['都市', '美食', '治愈', '日常'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: '11-1', title: '第1话 深夜来客', number: 1, updatedAt: '2026-04-10' },
      { id: '11-2', title: '第2话 泡菜汤的温度', number: 2, updatedAt: '2026-04-17' },
      { id: '11-3', title: '第3话 失恋的炸鸡', number: 3, updatedAt: '2026-04-24' },
      { id: '11-4', title: '第4话 妈妈的食谱', number: 4, updatedAt: '2026-05-01' },
      { id: '11-5', title: '第5话 加班族的慰藉', number: 5, updatedAt: '2026-05-08' },
      { id: '11-6', title: '第6话 老顾客的故事', number: 6, updatedAt: '2026-05-15' },
      { id: '11-7', title: '第7话 雨夜的拉面', number: 7, updatedAt: '2026-05-22' },
      { id: '11-8', title: '第8话 新菜单', number: 8, updatedAt: '2026-05-29' },
    ],
  },
  {
    id: '12',
    slug: 'vanished-truth',
    title: '消失的真相',
    author: '崔正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20manhwa%20cover%20with%20a%20detective%20examining%20evidence%20in%20a%20dimly%20lit%20room%2C%20crime%20scene%20elements%2C%20mysterious%20atmosphere%2C%20cool%20blue%20gray%20tones%2C%20suspenseful%20composition%2C%20clean%20noir%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '女记者韩雅琳调查一桩二十年前的悬案，却发现案件与当前一系列离奇事件密切相关。每一个线索都指向一个可怕的真相，而有人正在暗中阻止她接近真相。',
    status: '连载中',
    rating: 4.5,
    views: 670000,
    tags: ['悬疑', '推理', '记者', '犯罪'],
    updatedAt: '2026-07-30',
    chapters: [
      { id: '12-1', title: '第1话 尘封的档案', number: 1, updatedAt: '2026-05-01' },
      { id: '12-2', title: '第2话 匿名信件', number: 2, updatedAt: '2026-05-08' },
      { id: '12-3', title: '第3话 目击者', number: 3, updatedAt: '2026-05-15' },
      { id: '12-4', title: '第4话 跟踪', number: 4, updatedAt: '2026-05-22' },
      { id: '12-5', title: '第5话 危险的警告', number: 5, updatedAt: '2026-05-29' },
      { id: '12-6', title: '第6话 决断', number: 6, updatedAt: '2026-06-05' },
    ],
  },
  {
    id: '13',
    slug: 'iron-fist-legend',
    title: '铁拳传说',
    author: '郑泰元',
    cover: 'https://readdy.ai/api/search-image?query=An%20intense%20action%20Korean%20manhwa%20cover%20with%20a%20boxer%20in%20fighting%20stance%20in%20a%20boxing%20ring%2C%20dynamic%20motion%2C%20dramatic%20lighting%20from%20above%2C%20sweat%20and%20impact%20effects%2C%20powerful%20atmosphere%2C%20clean%20bold%20art%20style&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '地下格斗界的传奇拳手金泰成在一次比赛后神秘失踪。三年后，一个酷似他的年轻人出现在街头格斗场，带着全新的格斗技巧和不可告人的秘密。',
    status: '已完结',
    rating: 4.4,
    views: 920000,
    tags: ['动作', '格斗', '拳击', '街头'],
    updatedAt: '2026-05-15',
    chapters: [
      { id: '13-1', title: '第1话 地下拳王', number: 1, updatedAt: '2025-07-01' },
      { id: '13-2', title: '第2话 最后的比赛', number: 2, updatedAt: '2025-07-08' },
      { id: '13-3', title: '第3话 失踪', number: 3, updatedAt: '2025-07-15' },
      { id: '13-4', title: '第4话 三年后', number: 4, updatedAt: '2025-07-22' },
      { id: '13-5', title: '第5话 归来', number: 5, updatedAt: '2025-07-29' },
      { id: '13-6', title: '第6话 铁拳再现', number: 6, updatedAt: '2025-08-05' },
    ],
  },
  {
    id: '14',
    slug: 'spring-in-jeju',
    title: '济州岛的春天',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20peaceful%20Korean%20manhwa%20cover%20showing%20a%20woman%20enjoying%20spring%20in%20Jeju%20Island%20with%20yellow%20canola%20flowers%20and%20blue%20ocean%2C%20bright%20sunny%20day%2C%20healing%20atmosphere%2C%20soft%20natural%20colors%2C%20clean%20wholesome%20illustration&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    category: '治愈日常',
    categorySlug: 'healing',
    description: '厌倦了首尔快节奏生活的恩秀，决定搬到济州岛开始新生活。在岛上，她遇到了经营柑橘园的温暖一家人，重新找回了生活的美好与平静。',
    status: '连载中',
    rating: 4.9,
    views: 780000,
    tags: ['治愈', '旅行', '济州岛', '日常'],
    updatedAt: '2026-08-01',
    chapters: [
      { id: '14-1', title: '第1话 逃离首尔', number: 1, updatedAt: '2026-04-20' },
      { id: '14-2', title: '第2话 济州岛的第一天', number: 2, updatedAt: '2026-04-27' },
      { id: '14-3', title: '第3话 柑橘园的相遇', number: 3, updatedAt: '2026-05-04' },
      { id: '14-4', title: '第4话 海边的日出', number: 4, updatedAt: '2026-05-11' },
      { id: '14-5', title: '第5话 邻居们', number: 5, updatedAt: '2026-05-18' },
      { id: '14-6', title: '第6话 慢生活', number: 6, updatedAt: '2026-05-25' },
    ],
  },
  {
    id: '15',
    slug: 'kingdom-of-silla',
    title: '新罗王国',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20cover%20depicting%20Silla%20dynasty%20royal%20court%20with%20a%20prince%20and%20warriors%20in%20traditional%20armor%2C%20ancient%20Korean%20palace%20architecture%2C%20rich%20gold%20and%20red%20color%20scheme%2C%20epic%20historical%20atmosphere&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    category: '古风历史',
    categorySlug: 'historical',
    description: '以新罗王朝为背景，讲述了一位年轻王子在权谋斗争中成长为一代明君的故事。战场上的英勇与朝堂上的智慧，谱写了一段波澜壮阔的历史传奇。',
    status: '连载中',
    rating: 4.8,
    views: 1670000,
    tags: ['古风', '历史', '宫廷', '战争'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: '15-1', title: '第1话 王位之争', number: 1, updatedAt: '2026-01-10' },
      { id: '15-2', title: '第2话 花郎道', number: 2, updatedAt: '2026-01-17' },
      { id: '15-3', title: '第3话 边境烽火', number: 3, updatedAt: '2026-01-24' },
      { id: '15-4', title: '第4话 金城之战', number: 4, updatedAt: '2026-01-31' },
      { id: '15-5', title: '第5话 外交手腕', number: 5, updatedAt: '2026-02-07' },
      { id: '15-6', title: '第6话 内忧外患', number: 6, updatedAt: '2026-02-14' },
      { id: '15-7', title: '第7话 统一大业', number: 7, updatedAt: '2026-02-21' },
      { id: '15-8', title: '第8话 江山如画', number: 8, updatedAt: '2026-02-28' },
    ],
  },
  {
    id: '16',
    slug: 'campus-diary',
    title: '我们的校园时光',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=A%20youthful%20Korean%20manhwa%20cover%20with%20two%20students%20in%20school%20uniforms%20sharing%20headphones%20in%20a%20sunlit%20classroom%2C%20warm%20afternoon%20light%2C%20nostalgic%20school%20atmosphere%2C%20soft%20pastel%20colors%2C%20tender%20youth%20romance%20theme&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    category: 'BL/GL',
    categorySlug: 'bl-gl',
    description: '高中校园里，班长和转学生因为一次音乐课的偶然合作而相识。从最初的互不理解，到渐渐地被对方的才华和性格所吸引，青春的美好在这段关系中悄然绽放。',
    status: '已完结',
    rating: 4.7,
    views: 1100000,
    tags: ['校园', '青春', '音乐', 'BL'],
    updatedAt: '2026-04-20',
    chapters: [
      { id: '16-1', title: '第1话 转学生', number: 1, updatedAt: '2025-08-01' },
      { id: '16-2', title: '第2话 音乐课搭档', number: 2, updatedAt: '2025-08-08' },
      { id: '16-3', title: '第3话 放学后的钢琴室', number: 3, updatedAt: '2025-08-15' },
      { id: '16-4', title: '第4话 文化节', number: 4, updatedAt: '2025-08-22' },
      { id: '16-5', title: '第5话 烟花大会', number: 5, updatedAt: '2025-08-29' },
      { id: '16-6', title: '第6话 毕业', number: 6, updatedAt: '2025-09-05' },
    ],
  },
  {
    id: '17',
    slug: 'winter-sonata',
    title: '冬日恋歌',
    author: '金敏雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20winter%20Korean%20manhwa%20cover%20with%20a%20couple%20walking%20hand%20in%20hand%20through%20snowy%20Seoul%20streets%2C%20soft%20snowfall%2C%20warm%20street%20lights%2C%20cozy%20winter%20atmosphere%2C%20gentle%20romantic%20mood%2C%20clean%20delicate%20art%20style&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    description: '钢琴家韩在民因为手部受伤而陷入低谷，在滑雪场偶然遇到了热爱生活的滑雪教练柳娜。在银装素裹的世界里，一段温暖治愈的爱情故事悄然展开。',
    status: '连载中',
    rating: 4.6,
    views: 720000,
    tags: ['爱情', '冬季', '音乐', '治愈'],
    updatedAt: '2026-07-28',
    chapters: [
      { id: '17-1', title: '第1话 受伤的手指', number: 1, updatedAt: '2026-05-20' },
      { id: '17-2', title: '第2话 滑雪场', number: 2, updatedAt: '2026-05-27' },
      { id: '17-3', title: '第3话 钢琴与滑雪', number: 3, updatedAt: '2026-06-03' },
      { id: '17-4', title: '第4话 初雪', number: 4, updatedAt: '2026-06-10' },
      { id: '17-5', title: '第5话 勇气', number: 5, updatedAt: '2026-06-17' },
      { id: '17-6', title: '第6话 重返舞台', number: 6, updatedAt: '2026-06-24' },
    ],
  },
  {
    id: '18',
    slug: 'otherworld-gate',
    title: '异界之门',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20mysterious%20portal%20opening%20in%20a%20modern%20city%20with%20fantasy%20creatures%20emerging%2C%20stunning%20visual%20contrast%2C%20vibrant%20magical%20colors%2C%20urban%20fantasy%20theme%2C%20clean%20dynamic%20composition&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '首尔市中心突然出现了一扇通往异世界的大门，普通大学生金俊浩意外获得穿越两界的能力。在探索异世界的过程中，他发现这扇门的出现并非偶然。',
    status: '连载中',
    rating: 4.8,
    views: 2100000,
    tags: ['奇幻', '穿越', '都市', '冒险'],
    updatedAt: '2026-08-05',
    chapters: [
      { id: '18-1', title: '第1话 门出现了', number: 1, updatedAt: '2026-06-01' },
      { id: '18-2', title: '第2话 第一次穿越', number: 2, updatedAt: '2026-06-08' },
      { id: '18-3', title: '第3话 异世界的规则', number: 3, updatedAt: '2026-06-15' },
      { id: '18-4', title: '第4话 冒险者公会', number: 4, updatedAt: '2026-06-22' },
      { id: '18-5', title: '第5话 地下迷宫', number: 5, updatedAt: '2026-06-29' },
      { id: '18-6', title: '第6话 魔物潮', number: 6, updatedAt: '2026-07-06' },
      { id: '18-7', title: '第7话 守护者', number: 7, updatedAt: '2026-07-13' },
      { id: '18-8', title: '第8话 世界的真相', number: 8, updatedAt: '2026-07-20' },
    ],
  },
  {
    id: '19',
    slug: 'neon-seoul',
    title: '霓虹首尔',
    author: '李秀妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20manhwa%20cover%20showing%20fashionable%20young%20people%20in%20neon%20lit%20Seoul%20nightlife%20district%2C%20colorful%20city%20lights%2C%20trendy%20urban%20atmosphere%2C%20modern%20aesthetic%2C%20clean%20contemporary%20illustration%20style&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    description: '三个从小在首尔一起长大的好友，在繁华的都市中各奔前程——一个成为时尚设计师，一个在娱乐圈打拼，一个选择了普通的上班族生活。三种不同的人生，在霓虹闪烁的首尔交织。',
    status: '连载中',
    rating: 4.5,
    views: 650000,
    tags: ['都市', '友情', '时尚', '成长'],
    updatedAt: '2026-07-25',
    chapters: [
      { id: '19-1', title: '第1话 三个人的约定', number: 1, updatedAt: '2026-04-01' },
      { id: '19-2', title: '第2话 设计师之路', number: 2, updatedAt: '2026-04-08' },
      { id: '19-3', title: '第3话 试镜', number: 3, updatedAt: '2026-04-15' },
      { id: '19-4', title: '第4话 平凡的日子', number: 4, updatedAt: '2026-04-22' },
      { id: '19-5', title: '第5话 重逢', number: 5, updatedAt: '2026-04-29' },
      { id: '19-6', title: '第6话 各自的选择', number: 6, updatedAt: '2026-05-06' },
    ],
  },
  {
    id: '20',
    slug: 'revenge-code',
    title: '复仇密码',
    author: '崔正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20hacker%20themed%20Korean%20manhwa%20cover%20with%20a%20person%20in%20dark%20hoodie%20typing%20on%20laptop%20with%20digital%20code%20reflections%2C%20cyberpunk%20aesthetic%2C%20dark%20room%20with%20monitor%20glow%2C%20mysterious%20tech%20atmosphere%2C%20clean%20noir%20art&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '天才黑客朴智勋发现父亲的公司破产背后隐藏着一个庞大的金融诈骗网络。他利用自己的技术能力，一步步揭开真相，但每接近真相一步，危险就靠近一分。',
    status: '连载中',
    rating: 4.6,
    views: 580000,
    tags: ['悬疑', '黑客', '金融', '复仇'],
    updatedAt: '2026-07-22',
    chapters: [
      { id: '20-1', title: '第1话 破产', number: 1, updatedAt: '2026-05-10' },
      { id: '20-2', title: '第2话 父亲的遗物', number: 2, updatedAt: '2026-05-17' },
      { id: '20-3', title: '第3话 潜入系统', number: 3, updatedAt: '2026-05-24' },
      { id: '20-4', title: '第4话 第一个线索', number: 4, updatedAt: '2026-05-31' },
      { id: '20-5', title: '第5话 匿名举报', number: 5, updatedAt: '2026-06-07' },
      { id: '20-6', title: '第6话 反击', number: 6, updatedAt: '2026-06-14' },
    ],
  },
  {
    id: '21',
    slug: 'sword-of-destiny',
    title: '命运之剑',
    author: '郑泰元',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20action%20Korean%20manhwa%20cover%20with%20a%20swordsman%20holding%20a%20glowing%20sword%20in%20ancient%20battlefield%2C%20dramatic%20sunset%20sky%2C%20epic%20scale%2C%20dynamic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20clean%20heroic%20art%20style&width=400&height=560&seq=comic-cover-21&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '传说中有一把能够改变命运的剑。少年剑客在寻找这把剑的旅途中，遇到了志同道合的伙伴，也遭遇了前所未有的强敌。这是一段关于成长、友情与信念的热血冒险。',
    status: '连载中',
    rating: 4.5,
    views: 1380000,
    tags: ['动作', '武侠', '冒险', '友情'],
    updatedAt: '2026-08-02',
    chapters: [
      { id: '21-1', title: '第1话 传说中的剑', number: 1, updatedAt: '2026-03-10' },
      { id: '21-2', title: '第2话 踏上旅途', number: 2, updatedAt: '2026-03-17' },
      { id: '21-3', title: '第3话 剑术大师', number: 3, updatedAt: '2026-03-24' },
      { id: '21-4', title: '第4话 伙伴集结', number: 4, updatedAt: '2026-03-31' },
      { id: '21-5', title: '第5话 试剑大会', number: 5, updatedAt: '2026-04-07' },
      { id: '21-6', title: '第6话 暗影组织', number: 6, updatedAt: '2026-04-14' },
      { id: '21-7', title: '第7话 古墓探秘', number: 7, updatedAt: '2026-04-21' },
      { id: '21-8', title: '第8话 剑的真相', number: 8, updatedAt: '2026-04-28' },
    ],
  },
  {
    id: '22',
    slug: 'garden-of-words',
    title: '言叶之庭',
    author: '尹智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20serene%20Korean%20manhwa%20cover%20showing%20a%20beautiful%20Japanese%20style%20garden%20with%20a%20young%20woman%20reading%20under%20a%20tree%2C%20soft%20dappled%20sunlight%2C%20peaceful%20atmosphere%2C%20gentle%20green%20and%20warm%20tones%2C%20clean%20healing%20illustration&width=400&height=560&seq=comic-cover-22&orientation=portrait',
    category: '治愈日常',
    categorySlug: 'healing',
    description: '失去说话能力的画家美京，在一座古老庭院中找到了内心的平静。通过在庭院中观察四季变化、照料花草，她逐渐用画笔重新与世界对话。',
    status: '已完结',
    rating: 4.9,
    views: 530000,
    tags: ['治愈', '艺术', '自然', '成长'],
    updatedAt: '2026-03-30',
    chapters: [
      { id: '22-1', title: '第1话 沉默', number: 1, updatedAt: '2025-10-01' },
      { id: '22-2', title: '第2话 庭院', number: 2, updatedAt: '2025-10-08' },
      { id: '22-3', title: '第3话 第一幅画', number: 3, updatedAt: '2025-10-15' },
      { id: '22-4', title: '第4话 花开有声', number: 4, updatedAt: '2025-10-22' },
      { id: '22-5', title: '第5话 重新开口', number: 5, updatedAt: '2025-10-29' },
      { id: '22-6', title: '第6话 画展', number: 6, updatedAt: '2025-11-05' },
    ],
  },
  {
    id: '23',
    slug: 'goryeo-warrior',
    title: '高丽武士',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20cover%20with%20a%20fierce%20Goryeo%20warrior%20on%20horseback%20in%20full%20traditional%20armor%2C%20epic%20battlefield%20background%2C%20dramatic%20sky%2C%20rich%20earthy%20colors%2C%20powerful%20historical%20atmosphere&width=400&height=560&seq=comic-cover-23&orientation=portrait',
    category: '古风历史',
    categorySlug: 'historical',
    description: '高丽末期，契丹大军压境。普通农家出身的武士姜邯赞在国家危难之际挺身而出，率领义勇军抵御外敌。他的英勇事迹在民间广为流传，成为一代传奇。',
    status: '连载中',
    rating: 4.7,
    views: 1450000,
    tags: ['古风', '历史', '战争', '英雄'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: '23-1', title: '第1话 烽火连天', number: 1, updatedAt: '2026-02-01' },
      { id: '23-2', title: '第2话 从军', number: 2, updatedAt: '2026-02-08' },
      { id: '23-3', title: '第3话 初阵', number: 3, updatedAt: '2026-02-15' },
      { id: '23-4', title: '第4话 龟州大捷', number: 4, updatedAt: '2026-02-22' },
      { id: '23-5', title: '第5话 追击', number: 5, updatedAt: '2026-03-01' },
      { id: '23-6', title: '第6话 凯旋', number: 6, updatedAt: '2026-03-08' },
    ],
  },
  {
    id: '24',
    slug: 'moonlight-garden',
    title: '月光花园',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystical%20Korean%20manhwa%20cover%20with%20two%20women%20in%20a%20moonlit%20garden%20surrounded%20by%20glowing%20flowers%2C%20soft%20moonlight%2C%20magical%20atmosphere%2C%20ethereal%20beauty%2C%20gentle%20GL%20romance%20theme%2C%20clean%20enchanting%20art%20style&width=400&height=560&seq=comic-cover-24&orientation=portrait',
    category: 'BL/GL',
    categorySlug: 'bl-gl',
    description: '在月光下绽放的魔法花园中，守护花园的少女与误入花园的人类女孩相遇了。一个是长生不老的守护者，一个是生命有限的凡人，她们的相遇改变了花园的命运。',
    status: '连载中',
    rating: 4.8,
    views: 990000,
    tags: ['奇幻', 'GL', '魔法', '浪漫'],
    updatedAt: '2026-08-01',
    chapters: [
      { id: '24-1', title: '第1话 月光之夜', number: 1, updatedAt: '2026-05-01' },
      { id: '24-2', title: '第2话 花园的来客', number: 2, updatedAt: '2026-05-08' },
      { id: '24-3', title: '第3话 守护者的秘密', number: 3, updatedAt: '2026-05-15' },
      { id: '24-4', title: '第4话 月光下的对话', number: 4, updatedAt: '2026-05-22' },
      { id: '24-5', title: '第5话 盛开的花', number: 5, updatedAt: '2026-05-29' },
      { id: '24-6', title: '第6话 选择', number: 6, updatedAt: '2026-06-05' },
    ],
  },
];